import { IDs } from '../../../helpers/IDs';


export function extractEnergieKennzahlen(data: any, base: any, standort: any) {
    const standorte = data[IDs.ENT_STANDORT];
    const kz_dyna = data[IDs.ENT_KENNZAHLEN_DYNAMISCH];
    const kz_gewerk = data[IDs.ENT_KENNZAHLEN_WERTE];

    // Standorte-Map
    const veranstaltungen_enabled = Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0 ? data[IDs.ENT_KONFIGURATION][0].veranstaltungen_orig === 1 : false;
    const standorteMap: any = {};
    standorte
        // schließen deaktivierte Veranstaltungen oder Veranstaltungen ohne Standorte aus.
        .filter((s: any) => !((s.standort_typ_tid_orig === 5 || s.standort_typ_tid_orig === 6) && (!veranstaltungen_enabled || !s.standort_tid_orig)))
        .forEach((s: any) => standorteMap[s.tid] = s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1);

    /******************** KENNZIFFERN GEWERK ****************************************************** */
    kz_gewerk.filter((w: any) => kz_dyna.find((d: any) => d.kuerzel === w.kuerzel))
        .forEach((item: any) => {
            const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
            // console.log('ITEM', item);
            if (!standortTid || !standorteMap[standortTid] || (standort && standortTid !== standort.tid)) {
                return;
            }
            const jahr = item.jahr;
            if (!base[jahr]) {
                base[jahr] = {};
            }
            const kuerzel = item.kuerzel;
            const wert = +item.wert;
            base[jahr][kuerzel] = (base[jahr][kuerzel] || 0) + wert;
            // console.log('KZG', item);
        });
}


export function calculateEnergieKennzahlen(data: any, result: any, standort: any) {
    const standorte = data[IDs.ENT_STANDORT];
    const kz_gewerk = data[IDs.ENT_KENNZAHLEN_WERTE];

    // Standorte-Map
    const veranstaltungen_enabled = Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0 ? data[IDs.ENT_KONFIGURATION][0].veranstaltungen_orig === 1 : false;
    const standorteMap: any = {};
    standorte
        // schließen deaktivierte Veranstaltungen oder Veranstaltungen ohne Standorte aus.
        .filter((s: any) => !((s.standort_typ_tid_orig === 5 || s.standort_typ_tid_orig === 6) && (!veranstaltungen_enabled || !s.standort_tid_orig)))
        .forEach((s: any) => standorteMap[s.tid] = s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1);

    kz_gewerk.forEach((item: any) => {
        const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
        // console.log('ITEM', item);
        if (!standortTid || !standorteMap[standortTid] || (standort && standortTid !== standort.tid)) {
            return;
        }
        const jahr = item.jahr;
        const kuerzel = item.kuerzel;
        const wert = +item.wert;
        const kosten_total = result[jahr]['kosten_total'];
        const verbrauch_total = result[jahr]['verbrauch_total'];
        const calc_kosten = kosten_total / wert;
        const calc_verbrauch = verbrauch_total / wert;
        result[jahr]['energie_' + kuerzel] = calc_verbrauch;
        result[jahr]['kosten_' + kuerzel] = calc_kosten;
        // console.log('energie_' + kuerzel, jahr,  calc_verbrauch);
    });
}
